var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-base",
    { attrs: { title: _vm.$t(_vm.title) } },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("bk-choice", {
            staticClass: "bk-choice",
            attrs: {
              label: _vm.$t("STEP_ONE.I_AM"),
              choices: _vm.genderChoices,
              value: _vm.gender,
              name: "genderChoices"
            },
            on: { input: _vm.selectGender }
          }),
          _vm._v(" "),
          _c("bk-choice", {
            attrs: {
              label: _vm.$t("STEP_ONE.LOOKING_FOR"),
              choices: _vm.searchGenderChoices,
              value: _vm.searchGender,
              name: "searchGenderChoices"
            },
            on: { input: _vm.updateSearchGender }
          }),
          _vm._v(" "),
          _c("bk-age-select", {
            attrs: {
              value: [_vm.searchAgeRange.min, _vm.searchAgeRange.max],
              min: 18,
              max: 99,
              "min-range": 5
            },
            on: { change: _vm.updateSearchAgeRange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "buttons" },
        [
          _c("bk-button", { on: { click: _vm.navigate } }, [
            _vm._v(_vm._s(_vm.$t(_vm.buttonTitle)))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "usp" },
        [
          !_vm.coupon.isEmpty()
            ? _c("coupon-box")
            : _vm.promoter === "115"
            ? _c("premium-hint")
            : _c("usp-box")
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }